import { gql } from 'apollo-boost';

export const allProducts = gql`
  query product($orgId: ID!) {
    product {
      all(orgId: $orgId) {
        id
        changedUtc
        freightInfo {
          freightClassId
          nmfcItemCode
          nmfcSubCode
        }
        description
      }
    }
  }
`;

export const paginatedProducts = gql`
  query paginatedProducts(
    $orgId: ID!
    $limit: Int!
    $offset: Int!
    $searchText: String!
    $includeExpired: Boolean!
  ) {
    product {
      paged(
        orgId: $orgId
        limit: $limit
        offset: $offset
        searchText: $searchText
        includeExpired: $includeExpired
      ) {
        hasMoreData
        limit
        offset
        totalCount
        results {
          id
          changedUtc
          sku
          isHazMat
          name
          description
          rowVersion
          packageTypeId
          pieceCount
          active
          freightInfo {
            freightClassId
            nmfcItemCode
            nmfcSubCode
          }
          hazMat {
            contactFirstName
            contactLastName
            contactPhone
            hazMatClassId
            hazMatPackingGroupId
            properShippingName
            unNumber
          }
          weightInfo {
            weight
            weightUnit
          }
          valueInfo {
            currency
            value
          }
        }
      }
    }
  }
`;
